/**
 * Sidebar Tooltip Management
 * Dynamically enable/disable tooltips on sidebar links based on sidebar-mini state
 */

/* global MutationObserver */

export const initSidebarTooltips = () => {
  const sidebar = document.querySelector('.sidebar');
  if (!sidebar) return;

  let activeTooltips = [];

  const enableTooltips = () => {
    const navLinks = sidebar.querySelectorAll('.nav-link');
    navLinks.forEach((link) => {
      const linkText = link.textContent.trim();

      link.setAttribute('title', linkText);
      link.setAttribute('data-bs-toggle', 'tooltip');
      link.setAttribute('data-bs-placement', 'right');

      const tooltip = new bootstrap.Tooltip(link);
      activeTooltips.push(tooltip);
    });
  };

  const disableTooltips = () => {
    activeTooltips.forEach((tooltip) => tooltip.dispose());
    activeTooltips = [];
  };

  // Global function to hide all tooltips (used by flyout handler)
  window.hideAllTooltips = () => {
    activeTooltips.forEach((tooltip) => tooltip.hide());
  };

  const handleSidebarStateChange = () => {
    if (sidebar.classList.contains('sidebar-mini')) {
      enableTooltips();
    } else {
      disableTooltips();
    }
  };

  // Initial check on page load
  handleSidebarStateChange();

  // Watch for class changes on .sidebar using MutationObserver
  const observer = new MutationObserver(handleSidebarStateChange);

  observer.observe(sidebar, {
    attributes: true,
    attributeFilter: ['class']
  });
};
